import axios from 'axios';

// Local testing flag: set VITE_USE_DEV_DB=true in .env.local (gitignored) to point the
// dashboard at a locally-run RAK.Server backed by the "dev_db" clone instead of production.
const useDevDb = import.meta.env.VITE_USE_DEV_DB === 'true';
const rawBaseUrl = useDevDb
  ? (import.meta.env.VITE_DEV_API_BASE_URL || 'http://localhost:5155')
  : (import.meta.env.VITE_API_BASE_URL || 'https://api.rimalalkhaleej.com');
export const API_BASE_URL = rawBaseUrl.replace(/\/+$/, '');

// Uploaded media (products, brands, advertisements, ...) is served from the apex domain in
// production, not the api. subdomain — RAK.Server's MediaStorage.BaseMediaUrl points there.
// In dev, RAK.Server serves media from the same host as the API, so this just reuses API_BASE_URL.
const rawMediaBaseUrl = useDevDb
  ? rawBaseUrl
  : (import.meta.env.VITE_MEDIA_BASE_URL || 'https://rimalalkhaleej.com');
export const MEDIA_BASE_URL = rawMediaBaseUrl.replace(/\/+$/, '');

if (useDevDb) {
  // eslint-disable-next-line no-console
  console.log(`[RAK] useDevDb enabled — API requests go to ${API_BASE_URL}`);
}

function getStoredAuthToken() {
  const raw = localStorage.getItem('authToken');
  if (!raw || raw === 'undefined' || raw === 'null') return null;
  const t = raw.trim();
  return t.length > 0 ? t : null;
}

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = getStoredAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url ?? '';

    if (status === 401) {
      const isSignIn = url.includes('/api/admin/auth/signin');
      if (!isSignIn) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
